import { render, staticRenderFns } from "./clinicList.vue?vue&type=template&id=61bbbb60&scoped=true&"
import script from "./clinicList.vue?vue&type=script&lang=js&"
export * from "./clinicList.vue?vue&type=script&lang=js&"
import style0 from "./clinicList.vue?vue&type=style&index=0&id=61bbbb60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bbbb60",
  null
  
)

export default component.exports